import {prodEnvironment} from '../../../environments/environment.prod';
import {localEnvironment} from '../../../environments/environment.local';
import {intEnvironment} from '../../../environments/environment.int';
import {edpEnvironment} from '../../../environments/environment.edp';
import {dvpEnvironment} from '../../../environments/environment.dvp';
import {mreEnvironment} from '../../../environments/environment.mre';
import {supEnvironment} from '../../../environments/environment.sup';
import {uatEnvironment} from '../../../environments/environment.uat';
import {trgEnvironment} from '../../../environments/environment.trg';
import {MockPincodeService} from '../../services/pincode/mock-pincode.service';

export class Environment {
  constructor() {
  }

  public static environmentConfig() {
    const env = environment[Environment.getCurrentEnvironment()];
    if (Environment.isWebVersion()) {
      env.pincodeServiceType = MockPincodeService;
      return env;
    }
    return env;
  }

  public static getCurrentEnvironment(): string {
    const hostname = Environment.getHostName();
    if (hostname === 'localhost') {
      return 'local';
    }
    if (hostname.split('.')[1] === 'telenet') {
      return 'prd';
    }
    return hostname.split('.')[1];
  }

  static getHostName(): string {
    return window.location.hostname;
  }

  static isWebVersion(): boolean {
    return window.location.search.includes(IS_WEB_VERSION_PARAM);
  }
}

export const IS_WEB_VERSION_PARAM = 'isWebVersion=true';

export const environment = {
  prd: prodEnvironment,
  trg: trgEnvironment,
  uat: uatEnvironment,
  sup: supEnvironment,
  int: intEnvironment,
  mre: mreEnvironment,
  edp: edpEnvironment,
  dvp: dvpEnvironment,
  local: localEnvironment,
};
